import React, { useEffect, useState } from "react";
import { useParams, NavLink, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { FaSearch, FaUserCircle } from "react-icons/fa";
import { blogs } from "../Blog";
import ErrorPage from './ErrorPage'
import Breadcrumb from "../Components/Breadcrumb";
import bgImg from '../Images/blogs.webp'
import BlogPostingSchema from "../Schema/BlogPostingSchema";
import BreadcrumbSchema from "../Schema/BreadcrumbSchema";

const BlogDetail=()=>{
    const { slug } = useParams();
    const navigate = useNavigate();
const [searchTerm, setSearchTerm] = useState("");

  const blog = blogs.find(item => item.slug === slug);

  useEffect(() => {
      if (!blog) return;
      document.title = `${blog.metaTitle}`;

      const metaDesc = document.querySelector(
        "meta[name='description']"
      );
      if (metaDesc) {
        metaDesc.setAttribute("content", blog.metaDesc);
      }

        let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }

  canonical.setAttribute(
    "href",
    `https://msayurved.com/blog/${slug}`
  );

   const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      blog.metaTitle
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      blog.metaDesc
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content",  `https://msayurved.com/blog/${slug}`);
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      blog.img
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
     blog.metaTitle
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
   blog.metaDesc
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      blog.img
    );
  }

    }, [blog, slug]);


  if (!blog) {
    return <ErrorPage />;
  }

const safeBlogs = Array.isArray(blogs) ? blogs : [];

const categoriesList = [];

safeBlogs.forEach((item) => {
  if (
    item?.category &&
    !categoriesList.includes(item.category)
  ) {
    categoriesList.push(item.category);
  }
});

/*const tags = categoriesList;*/

const suggestions = [];

const cleanTerm = searchTerm.trim().toLowerCase();

if (cleanTerm !== "") {

  categoriesList.forEach((cat) => {

    if (
      cat.toLowerCase().includes(cleanTerm)
    ) {
      suggestions.push({
        type: "category",
        value: cat,
      });
    }

  });

  safeBlogs.forEach((item) => {

    if (
      item?.title &&
      item.title.toLowerCase().includes(cleanTerm)
    ) {
      suggestions.push({
        type: "blog",
        value: item.title,
        slug: item.slug,
      });
    }

  });

}

const handleSearchSubmit = () => {

  if (suggestions.length > 0) {

    const topResult = suggestions[0];

    if (topResult.type === "category") {

      navigate("/blog", {
        state: {
          selectCategory: topResult.value,
        },
      });

    } else {

      navigate(`/blog/${topResult.slug}`);
      setSearchTerm("");

    }

  } else if (searchTerm.trim() !== "") {

    navigate("/blog", {
      state: {
        searchString: searchTerm,
      },
    });

  }

};

const handleKeyDown = (e) => {

  if (e.key === "Enter") {
    handleSearchSubmit();
  }

};

const handleCategoryClick = (
  categoryName
) => {

  navigate("/blog", {
    state: {
      selectCategory: categoryName,
    },
  });

};

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 35,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      ease: "easeOut",
    },
  },
};

const sidebarVariant = {
  hidden: {
    opacity: 0,
    x: 40,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 1,
      ease: "easeOut",
    },
  },
};

const contentVariant = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 1.2,
      delay: 0.3,
    },
  },
};

const cardVariant = {
  hidden: {
    opacity: 0,
    y: 30,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

const sectionVariant = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const breadcrumbItems = [
    {
      name: "Home",
      url: "https://msayurved.com/"
    },
    {
      name: "Blog",
      url: "https://msayurved.com/blog/"
    },
    {
      name: blog.title,
      url: `https://msayurved.com/blog/${blog.slug}`
    }
  ];

    return(
        <>
        <React.Fragment key={slug}>

          <BlogPostingSchema blog={blog} />

      <BreadcrumbSchema items={breadcrumbItems} />

            {/**BREADCRUMB SECTION */}
        <Breadcrumb
        title={blog.title}
        bgImage={bgImg}
        />

        {/**BLOG CONTENT + SIDEBAR */}
        <section
  className="blog-detail-section container"
>

  {/* LEFT CONTENT */}

  <motion.div
    className="blog-detail-left"
    variants={fadeUp}
  >

    <motion.h2
      className="section-heading"
      variants={fadeUp}
    >
      {blog.title}
    </motion.h2>

    <motion.p
      className="section-text blog-detail-intro"
      variants={fadeUp}
    >
      {blog.blogDetailIntro}
    </motion.p>

    <motion.img
      src={blog.img}
      alt={`${blog.title} | Dr. Jigar Gor's Ayurveda`}
      className="blog-detail-image"
      initial={{
        opacity: 0,
        scale: 1.03,
      }}
      whileInView={{
        opacity: 1,
        scale: 1,
      }}
      viewport={{
        once: true,
      }}
      transition={{
        duration: 1.2,
        ease: "easeOut",
      }}
    />

    <motion.div
      className="blog-detail-content"
      variants={contentVariant}
      dangerouslySetInnerHTML={{
        __html: blog.content,
      }}
    />

  </motion.div>

  {/* RIGHT SIDEBAR */}

  <motion.div
    className="blog-detail-sidebar"
    variants={sidebarVariant}
  >

    {/* AUTHOR */}

    <motion.div
      className="blog-sidebar-card author-card"
      initial={{
        opacity: 0,
        y: 20,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      viewport={{
        once: true,
      }}
      transition={{
        duration: 0.8,
      }}
    >

      <div className="author-card-top">

        <motion.div
          className="author-image"
          whileHover={{
            scale: 1.05,
          }}
          transition={{
            duration: 0.3,
          }}
        >
          <FaUserCircle />
        </motion.div>

        <div>

          <h3 className="card-heading">
            Dr. Jigar Gor
          </h3>

          <p className="section-text">
            Posted on : {blog.date}
          </p>

        </div>

      </div>

    </motion.div>

    {/* SEARCH */}

    <motion.div
      className="blog-sidebar-card-blog-detail"
      initial={{
        opacity: 0,
        y: 20,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      viewport={{
        once: true,
      }}
      transition={{
        duration: 0.8,
        delay: 0.1,
      }}
    >
<div className="blog-search-blog-detail">

  <input
    type="text"
    placeholder="Search Category / Articles"
    value={searchTerm}
    onChange={(e) =>
      setSearchTerm(e.target.value)
    }
    onKeyDown={handleKeyDown}
  />

  {suggestions.length > 0 && (
    <div className="blog-search-dropdown">

      {suggestions.map((item, idx) => (

        <div
          key={idx}
          className="blog-search-item"
          onClick={() => {

            if (
              item.type === "category"
            ) {

              handleCategoryClick(
                item.value
              );

            } else {

              navigate(
                `/blog/${item.slug}`
              );

              setSearchTerm("");

            }

          }}
        >
          <span>
            {item.type === "category"
              ? "Category"
              : "Blog"}
          </span>

          {item.value}
        </div>

      ))}

    </div>
  )}

  <div
    onClick={handleSearchSubmit}
    style={{
      cursor: "pointer",
    }}
  >
    <FaSearch />
  </div>

</div>

      <h3 className="card-heading">
        Categories
      </h3>

      <ul className="blog-categories-blog-detail">

        {categoriesList.map((item, index) => (
         <motion.li
  key={index}
  className="section-text"
  initial={{
    opacity: 0,
    x: 15,
  }}
  whileInView={{
    opacity: 1,
    x: 0,
  }}
  viewport={{
    once: true,
  }}
  transition={{
    duration: 0.6,
    delay: index * 0.05,
  }}
  onClick={() =>
    handleCategoryClick(item)
  }
  style={{
    cursor: "pointer",
  }}
>
  {item}
</motion.li>
        ))}

      </ul>

    </motion.div>

    {/* TAGS */}

    {/*<motion.div
      className="blog-sidebar-card-blog-detail"
      initial={{
        opacity: 0,
        y: 20,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      viewport={{
        once: true,
      }}
      transition={{
        duration: 0.8,
        delay: 0.2,
      }}
    >

      <h3 className="card-heading">
        Tags
      </h3>

      <ul className="blog-categories-blog-detail">

        {tags.map((item, index) => (
          <motion.li
            key={index}
            onClick={() =>
  handleCategoryClick(item)
}
style={{
  cursor: "pointer",
}}
            className="section-text"
            initial={{
              opacity: 0,
              x: 15,
            }}
            whileInView={{
              opacity: 1,
              x: 0,
            }}
            viewport={{
              once: true,
            }}
            transition={{
              duration: 0.5,
              delay: index * 0.05,
            }}
          >
            {item}
          </motion.li>
        ))}

      </ul>

    </motion.div>*/}

    {/* CTA */}

    <motion.div
      className="blog-cta-card-blog-detail"
      initial={{
        opacity: 0,
        y: 30,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      viewport={{
        once: true,
      }}
      transition={{
        duration: 1,
        delay: 0.3,
        ease: "easeOut",
      }}
    >

      <p className="section-subheading">
        Your Wellness, Our Commitment.
      </p>

      <h3 className="card-heading">
        Begin Your Healing Journey Today
      </h3>

      <p className="section-text">
        Experience the power of authentic Ayurveda through
        personalized consultations, holistic therapies,
        and time-tested healing practices designed to
        restore balance, improve overall well-being, and
        naturally transform your health from within. Our
        expert-guided treatments focus on identifying the
        root cause and helping you achieve long-lasting
        physical, mental, and emotional wellness.
      </p>

      <motion.div
        whileHover={{
          y: -2,
        }}
        transition={{
          duration: 0.3,
        }}
      >
        <NavLink
          to="/book-appointment"
          className="nav-btn"
        >
          Book Appointment
        </NavLink>
      </motion.div>

    </motion.div>

  </motion.div>

</section>

        {/**OTHER BLOGS SECTION */}

<motion.section
  className="other-blogs-section container"
  variants={sectionVariant}
  initial="hidden"
  whileInView="visible"
  viewport={{
    once: true,
    amount: 0.15,
  }}
>
  <motion.p
    className="section-subheading"
    variants={fadeUp}
  >
    Insights & Articles
  </motion.p>

  <motion.h2
    className="section-heading"
    variants={fadeUp}
  >
    Read Other Related Articles
  </motion.h2>

  <motion.div
    className="other-blogs-grid"
    variants={sectionVariant}
  >
    {blogs
      .filter(item => item.slug !== blog.slug)
      .slice(0, 2)
      .map((item, index) => (
        <motion.div
          key={index}
          className="blog-card"
          variants={cardVariant}
          whileHover={{
            y: -5,
          }}
          transition={{
            duration: 0.4,
          }}
        >
          <div
            className="blog-image"
            style={{
              overflow: "hidden",
            }}
          >
            <motion.img
              src={item.img}
              alt={`${item.title} | Dr. Jigar Gor's Ayurveda`}
              whileHover={{
                scale: 1.05,
              }}
              transition={{
                duration: 0.8,
              }}
            />
          </div>

          <div className="blog-card-content">
            <h3 className="card-heading">
              <NavLink to={`/blog/${item.slug}`}>
                {item.title}
              </NavLink>
            </h3>

            <p className="section-text">
              {item.intro}
            </p>

            <motion.div
              whileHover={{
                x: 6,
              }}
              transition={{
                duration: 0.3,
              }}
            >
              <NavLink
                to={`/blog/${item.slug}`}
                className="blog-read-more"
              >
                Read Full Article →
              </NavLink>
            </motion.div>
          </div>
        </motion.div>
      ))}
  </motion.div>
</motion.section>

        </React.Fragment>
        </>
    )
}
export default BlogDetail;